module.exports = __webpack_public_path__ + "img/img-img-bankbook.284a9a8d.svg";